import { atomWithStorage } from "jotai/utils";
export const selectedLanguageAtom = atomWithStorage("@arc/shared/selectedLanguage", undefined, undefined, {
    getOnInit: true,
});
//# sourceMappingURL=ui.js.map